import { BaseDto } from './base.dto';
import { ModifierDto } from './modifier.dto';
import { RecipeDto } from './recipe.dto';

export class ModifierRecipeDto extends BaseDto {
  effectiveDate: Date
  portions: number;
  recipe: RecipeDto;
  modifier: ModifierDto;

  //just some variables to help to manage the logic
  costCalculated?: number;
  toAdd? = false;
  toUpdate? = false;

  constructor(
    recipe: RecipeDto,
    modifier: ModifierDto,
    effectiveDate: Date,
    portions: number
  ) {
    super();
    this.recipe = recipe;
    this.modifier = modifier;
    this.effectiveDate = effectiveDate;
    this.portions = portions;
  }
}
